/**
 * `window.sessionStorage` can be null (Android WebViews with DOM storage
 * disabled), throw on access (cookies blocked), or throw on write (quota,
 * private mode). These helpers never throw; reads fall back to null and
 * writes report success as a boolean.
 */

export const getSessionStorageItem = (key: string): string | null => {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setSessionStorageItem = (key: string, value: string): boolean => {
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
};

export const removeSessionStorageItem = (key: string): boolean => {
  try {
    window.sessionStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};
